import TextField from "../../../../components/fields/textField/TextField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue";
import AutocompleteField from "../../../../components/fields/autocompleteField/AutocompleteField.vue";
import ConfirmPasswordDialog from "../../../../components/dialog/confirmPassword/ConfirmPasswordDialog.vue";
import FormDialog from "../../../../components/dialog/form/FormDialog.vue";
import PerfilService from "../../../../services/PerfilService";
import { FeriasEscolaresService } from "../../../../services/FeriasEscolaresService";
import { SnackbarMixin } from "../../../../mixins/snackbarMixin.js";
import { AssinaturaMixin } from "../../../../mixins/assinaturaMixin.js";
import {SnackBarModule} from "@/modules/SnackBarModule";



export default {
  name: "FormPefis",
  components: {
    TextField,
    TextAreaField,
    ConfirmPasswordDialog,
    AutocompleteField,
    FormDialog,
    SnackBarModule
  },
  props: {
    optionsUnidades: {
      default: () => [],
      type: Array,
    },
  },
  mixins: [SnackbarMixin,AssinaturaMixin],
  data: () => ({
    perfilid: null,
    formTitle: "",
    formType: "New",
    showFormDialog: false,
    showFormUnidadesDeEnsino: false,
    disabled: {
      nome: false,
      permissoes: false,
    },
    form: {},
    formValid: true,
    unidades: [],
    showDialogConfirmPassword: false,
    formConfirmPassword: {},
    send: {
      function: () => {},
      params: null,
    },

    errors: [],
    permissions: [],
  }),

  created() {
    this.initializeFormConfirmPassword();
    this.listaUnidadesDeEnsino();

    this.initializeForm();
    if (this.$route.params.perfilid) {
      this.editMode = true;
      this.perfilid = this.$route.params.perfilid;
      this.getEditData();
    }
  },
  methods: {
    async listaUnidadesDeEnsino()
    {
      const response = await FeriasEscolaresService.listaUnidadesDeEnsino();
      this.unidades = response.unidadesDeEnsino;
    },

    goTo(path) {
      this.$router.push(path);
    },

    initializeForm() {
      this.form = {
        nome: "",
        descricao: "",
        hierarquia: "",
      };
    },

    validaForm() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (this.formType == "New") {
          this.validaAssinatura(this.save);
        }
        return;
      }
      this.errors.push("Preencha os campos obrigatórios");
    },
    async save() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        let response = await PerfilService.cadastrarPerfil(this.form);
        console.log(SnackBarModule);
        if (!response.error) {
          const perfilid = await response.response;
          SnackBarModule("O perfil foi criado com sucesso","success");
          this.showFormDialog = !this.showFormDialog;
          this.$emit("perfilCriado", perfilid);
        } else {
          const message = response.message.err;
          console.log(message);
          SnackBarModule(message, "error");
          this.errors.push(message);
        }
        return;
      }
    },
    async saveUnidadesDeEnsino() {
      this.errors = [];
      if (this.$refs.form.validate()) {

        const form = new FormData();

        form.append("unidades", this.unidades);
    
        let response = await FeriasEscolaresService.saveUnidadesDeEnsino(form);
      
        if (!response.error) {
          SnackBarModule("Unidade(s) cadastrada(s) com sucesso!","success");
          this.showFormUnidadesDeEnsino = !this.showFormUnidadesDeEnsino;
        } else {
          const message = response.message.err;
          SnackBarModule(message, "error");
          this.errors.push(message);
        }
        return;
      }
    },

    activeFormDialog(title, type, perfilid = null) {
      this.perfilid = perfilid;
      this.errors = [];
      this.initializeForm();
      this.$refs.form.resetValidation();
      this.initializeForm();
      if (type === "Edit") {
        this.getDataForm(perfilid);
      }
      this.formTitle = title;
      this.formType = type;
      this.showFormDialog = !this.showFormDialog;
    },

    activeFormUnidadesDeEnsino(title) {
      this.errors = [];
      this.$refs.form.resetValidation();
      this.formTitle = title;
      this.showFormUnidadesDeEnsino = !this.showFormUnidadesDeEnsino;
    }
  },
};
